export default [
  // 订单支付页面
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/pages/pay/index.vue')
  },

]
